import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

const Header = () => {

  useEffect(() => {
    AOS.init({
    duration: 1400, 
    easing: 'ease-in-cubic',
    once: true,
    offset: 80,    
    });
  }, []);

  const handleScroll = () => {
    window.scrollBy({
      top: 5100,
      left: 0,
      behavior: 'smooth',
    });
  };

  return (
    <div>
      <section className=" body-font bg-[#d6b055] custom-xsm:h-[70vh] sm:h-[95vh] md:h-[80vh] h-[65vh] px-6 md:px-10 lg:px-20">
        <div className="container mx-auto flex flex-col md:flex-row items-center">

          <div className="mt-32 lg:flex-grow flex flex-col text-center md:text-left mt:10  md:mt-40 mb-12 lg:mb-36">

            <h1 data-aos="fade-up" data-aos-delay="900"
              className="text-[#040404] font-fancy font-bold title-font sm:text-3xl custom-xsm:text-xl md:text-2xl lg:text-3xl">
              Welcome to EZ Technologies
              <br />
            </h1>

            <h2 data-aos="fade-up" data-aos-delay="1000"
              className=" text-[#373739] font-fancy title-font text-sm md:text-base lg:text-lg">
              We drive innovation through cutting-edge software solutions and
              empower individuals with essential digital skills.
            </h2>

            <div className="flex justify-center md:justify-start mt-6">
              <button
                data-aos="fade-up"
                data-aos-delay="1100"
                onClick={handleScroll}
                className="font-fancy inline-flex text-white bg-[#010000f5] py-2 px-4 focus:outline-none hover:text-[#d6b055] rounded text-lg">
                Let's connect
              </button>
            </div>
          </div>

          <div data-aos="zoom-in" data-aos-delay="1200"
            className="w-full md:max-w-md lg:max-w-lg xl:max-w-xl lg:mt-36 sm:mb-8 lg:ml-8 md:mt-40 xl:mt-28">
            <img
              className="object-cover object-center w-full h-auto md:h-[250px] lg:h-[350px] xl:h-[450px]"
              alt="hero"
              src="/images/hero.png"
            />
          </div>

        </div>
      </section>
      <hr className='mt-32' />
    </div>
  );
};

export default Header;